import {
  Box,
  Card,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import request from "graphql-request";
import { createUploadLink } from "apollo-upload-client";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import BASEURL from "../../../pages/Utils/Baseurl";
import {
  allDeliveryList,
  bulkUpload,
  completedDeliveries,
  deleteDelivery,
  getDeliveryById,
  pastDeliveriesListQuery,
  updateDeliveryMutation,
} from "./graphQl";
import { MdChangeCircle } from "react-icons/md";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/LodingContext";
import SignaturePad from "signature_pad";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import { useMutation } from "@apollo/client";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PlaceIcon from "@mui/icons-material/Place";
import NewLocationPicker from "./locationPicker";
import { Article, PictureAsPdf } from "@mui/icons-material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import TanstackTableComponents from "../../../components/tabel";
import RoleAccess from "../../function/RoleAccess";

const ManageDeliveriesList = () => {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [deliveryData, setDeliveryData] = useState([]);

  const [tabValue, setTabValue] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [toDate, setToDate] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);
  const [checkindata, setcheckindata] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDeliveryId, setSelectedDeliveryId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [deliveryDetails, setDeliveryDetails] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [mapOpen, setMapOpen] = useState(false);
  const [cheeckinoutopen, setcheckinoutopen] = useState(false);
  const [UpdateFile] = useMutation(bulkUpload);
  const { userId } = useAuthData();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const [searchValue, setSearchValue] = useState("");

  //useEffect to Fetch Table Data
  useEffect(() => {
    fetchDeliveryTableData();
  }, [tabValue, searchValue, pagination, fromDate, toDate]);

  //Date Filter
  const filteredReturns = deliveryData?.filter((item) => {
    if (!fromDate || !toDate) return true;

    const created = new Date(item.createdAt);
    const from = new Date(fromDate);
    const to = new Date(toDate);

    return created >= from && created <= to;
  });

  //Signature Upload
  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });

  //Location On-click Function
  const handleLocation = (value) => {
    const checkinData = value?.deliverypersoncheckinSet || [];
    const checkOutData = value?.deliverypersoncheckoutSet || [];
    const status = checkinData.length === 0;

    if (status) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "No Check-in",
        showConfirmButton: true,
      });
      return;
    }

    const transformedCheckinData = {
      ...value,
      checkins: checkinData.map((entry) => ({
        checkInTime: entry.checkInTime,
        checkinLocationLat: entry.checkinLocationLat,
        checkinLocationLng: entry.checkinLocationLng,
      })),
      checkouts: checkOutData.map((entry, index) => {
        const checkInTimeStr = checkinData[index]?.checkInTime;
        const checkOutTimeStr = entry.checkOutTime;
        // duration is calculated based on check-out time minus check-in time
        let duration = "0 seconds"; //if not available, default to 0 seconds

        if (checkInTimeStr && checkOutTimeStr) {
          const [inH, inM, inS] = checkInTimeStr.split(":").map(Number);
          const [outH, outM, outS] = checkOutTimeStr.split(":").map(Number);

          const checkInSeconds = inH * 3600 + inM * 60 + inS;
          const checkOutSeconds = outH * 3600 + outM * 60 + outS;

          const diff = checkOutSeconds - checkInSeconds;

          if (diff > 0) {
            const minutes = Math.floor(diff / 60);
            const seconds = diff % 60;
            duration =
              minutes > 0
                ? `${minutes} minute${
                    minutes !== 1 ? "s" : ""
                  } ${seconds} second${seconds !== 1 ? "s" : ""}`
                : `${seconds} second${seconds !== 1 ? "s" : ""}`;
          }
        }

        return {
          checkOutTime: entry.checkOutTime,
          checkoutLocationLat: entry.checkoutLocationLat,
          checkoutLocationLng: entry.checkoutLocationLng,
          duration,
        };
      }),
    };

    setcheckindata(transformedCheckinData);
    setcheckinoutopen(true);
  };

  //Table Mapping
  const deliveryTable = {
    columns: [
      {
        header: "Delivery ID",
        accessorKey: "deliveryId",
        cell: (props) => <p>{props.getValue()}</p>,
        meta: {
          sticky: true,
          left: 0,
        },
      },
      {
        header: "So Number",
        accessorKey: "soNumber",
        cell: (props) => <p>{props.getValue()}</p>,
              meta: {
          sticky: true,
          left: 80,
        },
      },
      {
        header: "Customer",
        accessorKey: "customer",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Delivered By",
        accessorKey: "deliveredBy",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Created By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: (props) => props.getValue(),
      },
      {
        header: "Created On",
        accessorKey: "createdOn",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Delivered On",
        accessorKey: "deliveredOn",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => props.getValue(),
      },
    ],

    rows: deliveryData.map((value, index) => ({
      id: value.id,
      sno: index + 1,
      soNumber: value?.salesOrder?.soNumber,
      createdOn: new Date(value.createdAt).toLocaleDateString(),
      deliveredBy: value.repName,
      customer: value.customerName,
      deliveredOn: new Date(value.deliveredOn).toLocaleDateString(),
      deliveryId: value.deliveryId,
      createdBy: value?.user?.employeeName,

      status: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color:
                value?.deliveryStatus?.toLowerCase() === "pending"
                  ? "#FFC107"
                  : value?.deliveryStatus?.toLowerCase() === "delivered"
                  ? "#4CAF50"
                  : value?.deliveryStatus?.toLowerCase() === "not delivered"
                  ? "#F44336"
                  : "",
            }}
          >
            {value?.deliveryStatus}
          </Typography>
        </Box>
      ),

      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          {(value?.deliveryStatus?.toLowerCase() === "delivered" ||
            value?.deliveryStatus?.toLowerCase() === "not delivered") && (
            <Tooltip title="Details">
              <Article
                fontSize="small"
                className="actionIcon"
                onClick={() => {
                  setSelectedDeliveryId(value?.id);
                  setSelectedStatus(value?.deliveryStatus?.toLowerCase());
                  fetchDeliveryById(value?.id);
                  setOpenDialog(true);
                }}
              />
            </Tooltip>
          )}
          <RoleAccess
            modelName="Manage Deliveries Screen"
            component="UpdateDelivery"
          >
            <MdChangeCircle
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "18px",
                marginRight: "20px",
              }}
              onClick={() => handleChangeStatus(value?.id)}
            />
          </RoleAccess>
          <RoleAccess
            modelName="Manage Deliveries Screen"
            component="ViewDelivery"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate("/Manage-Deliveries/Delivery-Form", {
                  state: { type: "view", rowId: value?.id },
                })
              }
            />
          </RoleAccess>

          <AccountBalanceWalletIcon
            fontSize="small"
            className="actionIcon"
            onClick={() =>
              navigate("/paymentBalance/paymentBalanceForm", {
                state: { type: "payment", deliveryId: value?.id },
              })
            }
          />

          <PictureAsPdf
            fontSize="small"
            className="actionIcon"
            onClick={() =>
              navigate("/Manage-Deliveries/Delivery-Receipt", {
                state: { type: "view", rowId: value?.id },
              })
            }
          />

          <LocationOnIcon
            fontSize="small"
            className="actionIcon"
            onClick={() => handleLocation(value)}
          />

          <RoleAccess
            modelName="Manage Deliveries Screen"
            component="DeleteDelivery"
          >
            {value?.deliverStatus?.toLowerCase() !== "delivered" && (
              <Tooltip title="Delete">
                <DeleteIcon
                  fontSize="small"
                  className="actionIcon"
                  onClick={() => handleDelete(value?.id, value?.deliverStatus)}
                />
              </Tooltip>
            )}
          </RoleAccess>
        </div>
      ),
    })),
  };

  //Status Change Pop up
  const handleChangeStatus = async (Id, val) => {
    let signaturePad = null;
    let signatureCanvas = null;
    const { value: formValues } = await Swal.fire({
      title: "Change Status",
      html: `
            <div style="text-align: left; font-family: Arial, sans-serif;">
                <!-- Status -->
                <label for="swal-status" style="font-weight: 600; display: block; margin-bottom: 6px;">Status*</label>
                <div style="border: 1px solid #d0d0d0; border-radius: 6px; padding: 6px 10px; margin-bottom: 18px; background-color: #f9f9f9;">
                <select id="swal-status" class="swal2-input" style="width: 100%; border: none; background: transparent; outline: none;">
                    <option value="">-- Select Status --</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Not Delivered">Not Delivered</option>
                </select>
                </div>

                <!-- Signature Pad -->
                <div id="signature-container" style="display: none; margin-bottom: 18px;">
                <label style="font-weight: 600; display: block; margin-bottom: 6px;">Customer Signature*</label>
                <canvas id="signature-pad" style="border: 1px solid #ccc; border-radius: 4px; width: 100%; height: 150px;"></canvas>
                </div>

                <!-- Reason Dropdown -->
                <div id="reason-container" style="display: none; margin-bottom: 18px; ">
                <label for="swal-reason" style="font-weight: 600; display: block; margin-bottom: 6px;">Reason for Not Delivery*</label>
                <div style="border: 1px solid #d0d0d0; border-radius: 6px; padding: 6px 10px; margin-bottom: 18px; background-color: #f9f9f9;">
                <select id="swal-reason" class="swal2-input" style="width: 100%; border: none; background: transparent; outline: none;">
                    <option value="">-- Select Reason --</option>
                    <option value="Customer not available">Customer not available</option>
                    <option value="Address not found">Address not found</option>
                    <option value="Product Damages during transit">Product Damages during transit</option>
                    <option value="Customer Refusal">Customer Refusal</option>
                    <option value="Quantity discrepancies">Quantity discrepancies</option>
                </select>
                </div>
                </div>

                <!-- Payment Mode -->
                <label for="payment-mode" style="font-weight: 600; display: block; margin-bottom: 6px;">Payment Mode*</label>
                <div style="border: 1px solid #d0d0d0; border-radius: 6px; padding: 6px 10px; margin-bottom: 18px; background-color: #f9f9f9;">
                <select id="payment-mode" class="swal2-input" style="width: 100%; border: none; background: transparent; outline: none;">
                    <option value="">-- Select Payment Mode --</option>
                    <option value="Cash on Delivery">Cash on Delivery</option>
                    <option value="Credit">Credit</option>
                    <option value="Advance">Advance</option>
                </select>
                </div>
            </div>
            `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      preConfirm: () => {
        const status = document.getElementById("swal-status").value;
        const reason = document.getElementById("swal-reason").value;
        const paymentMode = document.getElementById("payment-mode").value;

        if (!status) {
          Swal.showValidationMessage("Please select a status.");
          return;
        }

        if (status === "Not Delivered" && !reason) {
          Swal.showValidationMessage(
            "Please select a reason for Not Delivered."
          );
          return;
        }

        if (!paymentMode) {
          Swal.showValidationMessage("Please select a payment mode.");
          return;
        }

        if (status === "Delivered") {
          if (!signaturePad || signaturePad.isEmpty()) {
            Swal.showValidationMessage("Please draw a signature.");
            return;
          }

          // Correct way to export as image Blob
          return new Promise((resolve) => {
            signatureCanvas.toBlob((blob) => {
              if (blob && blob.size <= 5 * 1024 * 1024) {
                resolve({ status, reason, paymentMode, signatureBlob: blob });
              } else {
                Swal.showValidationMessage("Signature image exceeds 5MB.");
                resolve(); // returns undefined, cancels the modal
              }
            }, "image/png");
          });
        }

        return { status, reason, paymentMode, signatureBlob: null };
      },
      didOpen: () => {
        const canvas = document.getElementById("signature-pad");
        signatureCanvas = canvas; // store canvas
        signaturePad = new SignaturePad(canvas);

        const statusSelect = document.getElementById("swal-status");
        const reasonContainer = document.getElementById("reason-container");
        const signatureContainer = document.getElementById(
          "signature-container"
        );
        statusSelect.addEventListener("change", function () {
          const selected = this.value;
          if (selected === "Delivered") {
            signatureContainer.style.display = "block";
            reasonContainer.style.display = "none";

            // Resize canvas to be sharp on all displays
            const resizeCanvas = () => {
              const ratio = Math.max(window.devicePixelRatio || 1, 1);
              canvas.width = canvas.offsetWidth * ratio;
              canvas.height = canvas.offsetHeight * ratio;
              canvas.getContext("2d").scale(ratio, ratio);
              signaturePad.clear(); // Clear content on resize
            };
            resizeCanvas();
            window.addEventListener("resize", resizeCanvas);
          } else if (selected === "Not Delivered") {
            signatureContainer.style.display = "none";
            reasonContainer.style.display = "block";
          } else {
            signatureContainer.style.display = "none";
            reasonContainer.style.display = "none";
          }
        });
      },
    });

    if (formValues) {
      const { status, reason, paymentMode, signatureBlob } = formValues;
      try {
        setCirleLoading(true);
        const response = await client.mutate({
          mutation: updateDeliveryMutation,
          variables: {
            input: {
              id: Id,
              deliverStatus: status,
              reason: reason,
              paymentMode: paymentMode,
            },
            signature: signatureBlob || null,
          },
        });
        const successStatus = response.data.updateDelivery.success;
        const responseMessage = response.data.updateDelivery.message;
        if (successStatus) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: responseMessage,
            showConfirmButton: true,
          }).then(() => {
            navigate("/Manage-Deliveries");
          });
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: responseMessage,
            showConfirmButton: true,
          });
        }
      } catch (error) {
        console.error("Error submitting", error);
      } finally {
        setCirleLoading(false);
        fetchDeliveryTableData();
      }
    }
  };

  //Bulk Upload
  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          file: file,
          userid: userId,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.uploadDeliveryExcel?.success;
      const message = response?.data?.uploadDeliveryExcel?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchDeliveryTableData();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  //Delete Function
  const handleDelete = (deliveryId) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const response = await request(BASEURL, deleteDelivery, {
            deliveryId,
          });

          const success = response?.deleteDelivery?.success;
          const message = response?.deleteDelivery?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
          fetchDeliveryTableData();
        } catch (error) {
          console.error("Error Deleting Data: ", error);
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  //Fetch Table Data
  const fetchDeliveryTableData = async () => {
    setIsLoading(true);
    try {
      if (tabValue == 0) {
        fetchAllData();
      } else if (tabValue == 1) {
        fetchCompltedData();
      } else if (tabValue == 2) {
        fetchPastData();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCompltedData = async () => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, completedDeliveries, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        search: searchValue,
        startDate: fromDate == "" ? null : fromDate,
        endDate: toDate == "" ? null : toDate,
      });
      const success = res?.completedDeliveries?.success;
      const totalCount = res?.completedDeliveries?.totalCount;
      const totalPages = res?.completedDeliveries?.totalPages;
      if (success) {
        setDeliveryData(res?.completedDeliveries?.data);
        setDataCount({
          pageCount: totalPages,
          itemCount: totalCount,
        });
      } else {
        setDeliveryData([]);
        setDataCount({
          pageCount: 0,
          itemCount: 0,
        });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  const fetchPastData = async () => {
    setIsLoading(true);

    try {
      const res = await request(BASEURL, pastDeliveriesListQuery, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        search: searchValue,
        startDate: fromDate == "" ? null : fromDate,
        endDate: toDate == "" ? null : toDate,
      });
      const success = res?.pastDeliveries?.success;
      const totalCount = res?.pastDeliveries?.totalCount;
      const totalPages = res?.pastDeliveries?.totalPages;
      if (success) {
        setDeliveryData(res?.pastDeliveries?.data);
        setDataCount({
          pageCount: totalPages,
          itemCount: totalCount,
        });
      } else {
        setDeliveryData([]);
        setDataCount({
          pageCount: 0,
          itemCount: 0,
        });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAllData = async () => {
    setIsLoading(true);

    try {
      const res = await request(BASEURL, allDeliveryList, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        search: searchValue,
      });
      const success = res?.allDeliveries?.success;
      const totalCount = res?.allDeliveries?.totalCount;
      const totalPages = res?.allDeliveries?.totalPages;
      if (success) {
        setDeliveryData(res?.allDeliveries?.data);
        setDataCount({
          pageCount: totalPages,
          itemCount: totalCount,
        });
      } else {
        setDeliveryData([]);
        setDataCount({
          pageCount: 0,
          itemCount: 0,
        });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  //fetch Delivery details (paymentmode, signature and not deliver reason)
  const fetchDeliveryById = async (id) => {
    try {
      setCirleLoading(true);
      const res = await request(BASEURL, getDeliveryById, { id });

      const data = res.getDeliveryById?.data[0];

      console.log(data, "res");
      setDeliveryDetails(data);
    } catch (error) {
      console.error("Failed to fetch delivery details", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //Tab Value Switch handleChange
  const handleChange = (event, newValue) => {
    setDataCount({
      pageCount: 0,
      itemCount: 0,
    });
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setFromDate("");
    setToDate("");
    setDeliveryData([]);
    setTabValue(newValue);
  };

  //Download as Excel
  const exportToCSV = () => {
    const keysToExclude = ["id", "action", "user"];

    // Filter keys (headers)
    const headers = Object.keys(deliveryData[0])?.filter(
      (key) => !keysToExclude.includes(key)
    );

    const csvHeader = headers.join(",") + "\n";

    // Build rows with only allowed keys
    const csvRows = deliveryData
      .map((row) => headers.map((header) => row[header]).join(","))
      .join("\n");

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Delivery_List.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Show alert after a brief delay
    setTimeout(() => {
      Swal.fire({
        position: "top",
        icon: "success",
        title: "Delivery Excel Downloaded Successfully",
        showConfirmButton: true,
      });
    }, 500); // slight delay to allow download to trigger
  };

  //Handle Upload doc
  const handleUploadClick = () => {
    setUploadStatus(false); // reset first
    setTimeout(() => setUploadStatus(true), 0); // open again after reset
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  return (
    <DashboardLayout>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Delivery Details</DialogTitle>
        <DialogContent>
          {selectedStatus === "delivered" && (
            <Grid container spacing={2}>
              <Grid size={{ lg: 12, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Payment Mode
                  </MaterialTypography>
                  <MaterialInput
                    value={deliveryDetails?.paymentMode || ""}
                    disabled
                  />
                </MaterialBox>
              </Grid>
              <Grid size={{ lg: 12, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Signature
                  </MaterialTypography>
                </MaterialBox>
                {deliveryDetails?.signature ? (
                  <img
                    src={`${BASEURL.replace(/\/graphql\/?$/, "/media/")}${
                      deliveryDetails.signature
                    }`}
                    alt="Signature"
                    style={{
                      width: "100%",
                      height: "auto",
                      border: "1px solid #ccc",
                      marginTop: "8px",
                    }}
                  />
                ) : (
                  <MaterialTypography
                    variant="body2"
                    component="label"
                    fontWeight="bold"
                  >
                    No signature available
                  </MaterialTypography>
                )}
              </Grid>
            </Grid>
          )}
          {selectedStatus === "not delivered" && (
            <Grid container spacing={2}>
              <Grid size={{ lg: 12, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={deliveryDetails?.customerName || ""}
                  disabled
                />
              </Grid>
              <Grid size={{ lg: 12, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Not Delivered Reason
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={deliveryDetails?.reason || ""}
                  rows={2}
                  multiline
                  disabled
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        {selectedStatus === "not delivered" && (
          <DialogActions>
            <MaterialButton
              variant="gradient"
              color="error"
              size="small"
              onClick={() => setOpenDialog(false)}
            >
              Close
            </MaterialButton>
          </DialogActions>
        )}
      </Dialog>

      <Dialog open={cheeckinoutopen} onClose={() => setcheckinoutopen(false)}>
        <DialogTitle
          sx={{
            backgroundColor: "#2a9941",
            color: "white",
            fontWeight: "bold",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          Check-In & Check-Out Details
        </DialogTitle>

        <DialogContent
          sx={{
            backgroundColor: "#f9f9f9",
            padding: "20px",
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "0 10px",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#e3f2fd", borderRadius: 10 }}>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Check-in{" "}
                  <IconButton
                    onClick={() => {
                      setSelectedLocation({
                        lat: checkindata?.checkins[0]?.checkinLocationLat,
                        lng: checkindata?.checkins[0]?.checkinLocationLng,
                      });
                      setMapOpen(true);
                    }}
                    size="small"
                  >
                    <PlaceIcon fontSize="small" color="primary" />
                  </IconButton>
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Check-out{" "}
                  <IconButton
                    onClick={() => {
                      setSelectedLocation({
                        lat: checkindata?.checkouts[0]?.checkoutLocationLat,
                        lng: checkindata?.checkouts[0]?.checkoutLocationLng,
                      });
                      setMapOpen(true);
                    }}
                    size="small"
                  >
                    <PlaceIcon fontSize="small" color="error" />
                  </IconButton>
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Duration
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.2s",
                  borderRadius: 10,
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.01)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkins[0]?.checkInTime || "—"}
                </td>
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkouts[0]?.checkOutTime || "—"}
                </td>
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkouts[0]?.duration || "—"}
                </td>
              </tr>
            </tbody>
          </table>
        </DialogContent>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Delivery List
                  </MaterialTypography>
                </Stack>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <RoleAccess
                    modelName="Manage Deliveries Screen"
                    component="UploadDelivery"
                  >
                    <label
                      className="container-btn-file"
                      style={{
                        height: "38px",
                        marginLeft: "0",
                        display: "flex",
                        alignItems: "center",
                        marginRight: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                      onClick={() => handleUploadClick()} // show the modal
                    >
                      <svg
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 50 50"
                      >
                        <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                      </svg>
                      Upload File
                    </label>
                  </RoleAccess>

                  <RoleAccess
                    modelName="Manage Deliveries Screen"
                    component="ExportDelivery"
                  >
                    {deliveryData.length > 0 && (
                      <button
                        className="container-btn-file"
                        onClick={exportToCSV}
                        style={{
                          height: "38px",
                          marginLeft: "0",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "14px",
                          marginRight: "20px",
                        }}
                      >
                        <svg
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 50 50"
                        >
                          <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                        </svg>
                        Export File
                      </button>
                    )}
                  </RoleAccess>
                  <RoleAccess
                    modelName="Manage Deliveries Screen"
                    component="CreateDelivery"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() =>
                        navigate("/Manage-Deliveries/Delivery-Form", {
                          state: { type: "add" },
                        })
                      }
                    >
                      Delivery
                    </MaterialButton>
                  </RoleAccess>
                </Box>
              </Stack>
              {uploadStatus && (
                <FileUploadModal
                  key={Date.now()} // force remount
                  status={uploadStatus}
                  onClose={() => setUploadStatus(false)}
                  onSubmit={(file) => handleExcelUpload(file)}
                />
              )}
              <NewLocationPicker
                open={mapOpen}
                onClose={() => setMapOpen(false)}
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}
                designationData={deliveryData}
                setDesignationData={setDeliveryData}
                setMapOpen={setMapOpen}
                onSelectLocation={(location) => {
                  setDeliveryData({
                    ...deliveryData,
                    latitude: location.lat,
                    longitude: location.lng,
                    latitudeStatus: "success",
                    longitudeStatus: "success",
                  });
                  setMapOpen(false);
                }}
              />
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              ></Box>
              <Grid
                container
                spacing={2}
                sx={{ width: "100%", placeItems: "center" }}
              >
                <Grid size={{ lg: 5, xs: 12, sm: 3 }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#2a9941",
                        color: "white",
                      },
                    }}
                    centered
                  >
                    <Tab label="Today Delivery" />
                    <Tab label="Delivered" />
                    <Tab label="Past Delivery" />
                  </Tabs>
                </Grid>
                {tabValue != 0 && (
                  <>
                    <Grid size={{ lg: 3, xs: 6, sm: 3 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          From Date <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        type="date"
                        name="formDate"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </Grid>
                    <Grid size={{ lg: 3, xs: 6, sm: 3 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          To Date <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        type="date"
                        name="endDate"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </Grid>
                    <Grid size={{ lg: 1, xs: 6, sm: 2 }}>
                      <IconButton
                        onClick={() => {
                          setFromDate("");
                          setToDate("");
                        }}
                        aria-label="Reset Filters"
                        color="primary"
                        sx={{ mt: 2 }}
                      >
                        <RefreshIcon fontSize="large" />
                      </IconButton>
                    </Grid>
                  </>
                )}
              </Grid>
            </>
          }
        />
        <TanstackTableComponents
          rows={deliveryTable?.rows}
          columns={deliveryTable?.columns}
          pagination={pagination}
          setPagination={setPagination}
          pageCount={dataCount.pageCount}
          recordCount={dataCount.itemCount}
          isLoading={isLoading}
          isSearch={true}
          onChange={handleSearch}
        />
      </Card>
    </DashboardLayout>
  );
};

export default ManageDeliveriesList;
